import React, { useState } from 'react'
import './DeleteAccountModal.scss'
import { deleteAccount } from 'services/user'
import { navigate } from 'gatsby'
import { Box, Button, Typography } from '@mui/material'

const DeleteAccountModal = ({ closeModal }) => {
  const [loading, setLoading] = useState(false)
  const handleDeleteAccount = async e => {
    e.preventDefault()
    setLoading(true)
    await deleteAccount().then(res => {
      if (res.status === 200) {
        setLoading(false)
        navigate('/')
        closeModal()
      } else {
        closeModal()
        setLoading(false)
      }
    })
  }

  return (
    <Box className="modal-wrapper">
      <Typography id="modal-modal-title" variant="body1" component="span">
        Are you sure you want to delete your account?
      </Typography>
      <form className="modal-actions">
        <Button
          disabled={loading}
          onClick={closeModal}
          className="modal-cancel-button"
          variant="outlined"
        >
          Cancel
        </Button>
        <button
          type="button"
          disabled={loading}
          onClick={handleDeleteAccount}
          className="modal-confirm-button"
        >
          Yes
        </button>
      </form>
    </Box>
  )
}

export default DeleteAccountModal
